import { Injectable, Inject } from '@angular/core';
import { LOCAL_STORAGE, WebStorageService } from 'angular-webstorage-service';
import { Login } from '../share/login';

@Injectable()
export class SessionsService {
    public readonly LOGIN = 'login';
    public readonly PERMISSOES = 'permissoes';

    constructor(
        @Inject(LOCAL_STORAGE) private storage: WebStorageService
    ) { }

    /**
     * Método que criar uma sessão
     */
    setSessions(key, value) {
        this.storage.set(key, value);
    }

    /**
     * Método que carrega a sessão escolhida
     * @param nome Sessão escolhida
     */
    getSessions(nome) {
        return this.storage.get(nome);
    }

    getLogin(): Login {
        return this.storage.get(this.LOGIN);
    }

    /**
     * Método que apaga a sessão escolhida
     * @param nome Sessão escolhida
     */
    deleteSessions(nome) {
        this.storage.remove(nome)
    }
}
